import LogoImg from '@/assets/images/logo.svg?url'

export function LoadingFallback() {
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <img className="animate-pulse h-auto" src={LogoImg} alt="Loading" />
    </div>
  )
}
